import React, { useEffect, useState, useContext, useRef } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import CreateSizeChartModal from "pages/de/size-chart/components/CreateSizeChartModal";

const EmptySizeChartCard = ({ content = null, refresh = () => {} }) => {
  const [createSizeChartVisible, setCreateSizeChartVisible] = useState(false);

  const navigate = useNavigate();

  return (
    <SuiBox sx={{ my: 2, mx: 1 }}>
      <SuiBox
        sx={{
          border: "1px dashed",
          borderWidth: ({ borders }) => borders.borderWidth[2],
          borderSizeChart: ({ borders }) => borders.borderSizeChart,
          cursor: "pointer",
          height: 120,
          width: "100%",
          borderRadius: 4,
        }}
      >
        {content ? (
          content
        ) : (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ height: "100%", width: "100%" }}
            onClick={() => setCreateSizeChartVisible(true)}
          >
            <AddIcon fontSize="small" />
            <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
              Create Size Chart
            </SuiTypography>{" "}
          </SuiBox>
        )}
      </SuiBox>
      {createSizeChartVisible ? (
        <CreateSizeChartModal
          handleClose={() => setCreateSizeChartVisible(false)}
          visible={createSizeChartVisible}
          isEdit={false}
          handleRefresh={refresh}
        />
      ) : null}
    </SuiBox>
  );
};

export default EmptySizeChartCard;
